<his-documentation-link
	[target]="moduleOptions.DOCUMENTATION_ARTICLE"
	[title]="moduleOptions.DOCUMENTATION_TITLE">
</his-documentation-link>
<h1>{{'fs.res.publication.import' | hisUi}}</h1>
<p></p>

<div class="layoutBlock">
	<div *ngIf="interfaceTypes?.length" class="columnTwoThird">
		<p-panel header="{{'fs.res.publication.import.selectOrcidId' | hisUi}}">

            <div>
                <a class="transparent" routerLink="/pub/importsearchresult"
                    [queryParams]="{configFile: 'fs/res/searchPublicationImports.xml'}"
                    routerLinkActive="active">{{'fs.res.publication.import.candidates' | hisUi}}</a>
            </div>

            <his-plam [hidden]="searchResultsAreDisplayed">
                <p-autoComplete #content [dropdown]="true" hisDdKey="fs.res.publication.importSource"
                    [(ngModel)]="selectedInterfaceType" [suggestions]="filteredInterfaceTypes" field="systemName" (completeMethod)="search($event)">
                </p-autoComplete>
            </his-plam>

            <div [hidden]="!isOrcidImport">
                <res-publication-orcid-import (searchResultsAreDisplayed)="searchResultsAreDisplayed = $event"></res-publication-orcid-import>
            </div>

            <div *ngIf="isBibTexImport">
                <res-publication-bibtex-import></res-publication-bibtex-import>
            </div>

            <div *ngIf="isExcelImport">
                <res-publication-excel-import></res-publication-excel-import>
            </div>

            <ng-container *ngFor="let interfaceType of interfaceTypesThatRequireSearchconfig">
                <div *ngIf="interfaceType?.interfaceName === selectedInterfaceType?.interfaceName">
                    <res-publication-import-search-form [selectedInterfaceType]="selectedInterfaceType" [searchParams]="searchParams" [callerId]="'PublicationImportFormComponent'"></res-publication-import-search-form>
                </div>
            </ng-container>
		</p-panel>
	</div>
</div>
